import * as React from 'react'
import { Link } from 'react-router-dom'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

export const PricingPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>Pricing</PageTitle>
        <PageSubtitle>Plans that scale with your organization.</PageSubtitle>
      </MarketingSection>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem', marginTop: '2rem' }}>
        <div style={{ padding: '1.5rem', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8 }}>
          <h3>Free</h3>
          <p>Get started with core cap table features.</p>
          <Link to="/register" style={{ display: 'inline-block', marginTop: '1rem', padding: '0.5rem 1rem', background: '#33AA40', color: '#fff', borderRadius: 4, textDecoration: 'none' }}>Get Started</Link>
        </div>
        <div style={{ padding: '1.5rem', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8 }}>
          <h3>Pro</h3>
          <p>Advanced features, integrations, and support.</p>
          <Link to="/register" style={{ display: 'inline-block', marginTop: '1rem', padding: '0.5rem 1rem', background: '#33AA40', color: '#fff', borderRadius: 4, textDecoration: 'none' }}>Start trial</Link>
        </div>
        <div style={{ padding: '1.5rem', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8 }}>
          <h3>Enterprise</h3>
          <p>Custom plans and dedicated support.</p>
          <a href="mailto:support@equa.cc" style={{ display: 'inline-block', marginTop: '1rem', padding: '0.5rem 1rem', border: '1px solid currentColor', borderRadius: 4, color: 'inherit', textDecoration: 'none' }}>Contact sales</a>
        </div>
      </div>
    </MarketingPageContainer>
  </MarketingLayout>
)
